import type { SHORT_LOCALES } from '../locales.constants'

// Source of a locale change. Drives downstream funnel analysis:
//   - `switcher`       — user clicked <LanguageSwitcher/>
//   - `url-hint`       — `?lang=` in a shared URL applied at mount or via in-app nav
//   - `settings-save`  — Settings → Profile form just changed `traits.locale`;
//                        we reconcile `paretos_lang` cookie so cockpit / future
//                        apps follow without a relogin
//   - `identity-trait` — a signed-in screen adopting `identity.traits.locale`
//                        where it diverges from the resolved UI locale (e.g.
//                        browser Accept-Language won at first paint, but the
//                        account has a different preference). Fires once per
//                        mount of any such screen
export type LocaleChangeSource = 'switcher' | 'url-hint' | 'settings-save' | 'identity-trait'

export interface LocaleChangeEvent {
  from: SHORT_LOCALES
  to: SHORT_LOCALES
  source: LocaleChangeSource
}

// Single seam so a future PostHog / Sentry / backend pipeline only has to
// rewrite this function. Today it writes a structured `console.info` line so
// the event is grep-able in production browser logs and survives source-map
// strips. Silent in test runs to keep CI noise down.
export const emitLocaleChange = (event: LocaleChangeEvent): void => {
  if (process.env.NODE_ENV === 'test') {
    return
  }
  // eslint-disable-next-line no-console
  console.info('[locale]', event)
}
